import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import { languages } from "../../constants/languages";
import DivisionTabsContainer from "../../containers/DivisionTabsContainer";
import ExportRankingContainer from "../../containers/results/ExportRankingContainer";
import PlayerRankingContainer from "../../containers/results/PlayerRankingContainer";
import RankingTable from "./RankingTable";

export default class RankingDialog extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    let useSets = (this.props.tournament.useSets || "0") === "1";

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth={useSets ? "md" : "sm"}
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {languages.results.ranking}
        </DialogTitle>
        {this.props.showPlayerStats && (
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="off"
            variant="fullWidth"
            style={{ marginBottom: 10 }}
          >
            <Tab
              key={0}
              label={languages.tournament.teams}
              style={{ height: 40 }}
            />
            <Tab
              key={1}
              label={languages.tournament.players}
              style={{ height: 40 }}
            />
          </Tabs>
        )}
        {this.state.value === 0 && (
          <DialogContent style={{ paddingTop: 0 }}>
            <DialogContentText style={{ paddingBottom: 10 }}>
            {languages.formatString(languages.results.rankingDescription, 
            this.props.tournament.individualPlayers 
              ? languages.teams.playersLow
              : languages.tournament.teamsLow
            ) + " " + languages.results.rankingDescription2}
            </DialogContentText>
            <ExportRankingContainer
              ranking={this.props.ranking}
              divisionsObject={this.props.divisionsObject}
              useSets={useSets}
              tournament={this.props.tournament}
            />
            {this.props.divisions.length > 1 ? (
              <div style={{ marginTop: 5 }}>
                <DivisionTabsContainer
                  tournament={this.props.tournament}
                  divisions={this.props.divisions}
                  divisionsObject={this.props.divisionsObject}
                  ranking={this.props.ranking}
                  resultsPage={true}
                  customPoints={this.props.customPoints}
                />
              </div>
            ) : (
              <RankingTable
                tournament={this.props.tournament}
                ranking={this.props.ranking[0]}
                division={"0"}
                customPoints={this.props.customPoints}
                useSets={useSets}
              />
            )}
          </DialogContent>
        )}
        {this.state.value === 1 && (
          <DialogContent style={{ paddingTop: 0 }}>
            <PlayerRankingContainer {...this.props} />
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={this.props.handleClose}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.export.close}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
